module.exports = __webpack_public_path__ + "static/assets/29f6558a07459c1787681f11e59eeb6c.png";